'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useTracking } from '@/components/Tracking/useTracking'

// Every /p/<hash> route renders the class layout except the print view.
function isClassLayoutPath(pathname: string) {
  return (
    /^\/p\/[^/]+(?:\/|$)/.test(pathname) && !pathname.endsWith('/lesson-print')
  )
}

// Re-implementing page_view tracking to pass custom params (the url params).
// @see https://github.com/gatsbyjs/gatsby/tree/master/packages/gatsby-plugin-google-gtag/src
export function schedulePageView(send: () => void) {
  if (`requestAnimationFrame` in window) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setTimeout(send, 0))
    })
  } else {
    setTimeout(send, 32)
  }
}

export function TrackPageViews() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { track } = useTracking()

  useEffect(() => {
    // TrackClassProject sends these once the class layout has loaded, so the
    // event carries the project; sending here would race that load.
    if (isClassLayoutPath(pathname)) return

    schedulePageView(() => {
      track('page_view')
    })
  }, [pathname, searchParams, track])

  return null
}
